import { BaseBarChart, BaseLineChart } from '@rdrive/plugin-chart-bar-line';
import setup from './setup.js';

export default {
  name: 'documents-page',
  components: { BaseBarChart, BaseLineChart },
  setup,
};
